import { ReservationBookingPayment } from '@models/reception'

export const getReceptionBookingPayments = (bookingPayments: ReservationBookingPayment[], isDeposit) => {
  const depositTypes = ['deposit_return', 'deposit', 'deposit_used', 'deposit_move']

  return bookingPayments.filter(
    payment => depositTypes.includes(payment.type) === isDeposit && payment.source !== 'creditcard_preauth',
  )
}
